// @flow
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import type { ExpandedCoordinate } from './types';

type Props = {
  picture: Image,
  coord: ExpandedCoordinate,
};

const HighlightCoordinate = ({ img, picture, coord }: Props) => {
  const top = picture.current.getBoundingClientRect().top;
  const left = picture.current.getBoundingClientRect().left;
  const ratioX = picture.current.getBoundingClientRect().width / img.width;
  const ratioY = picture.current.getBoundingClientRect().height / img.height;
  const coords = { x: left + coord.x * ratioX, y: top + coord.y * ratioY };
  const menu = window.innerWidth >= 1280 ? 130 : 0;
  return (
    <CSSTransition in={true} classNames="ps__coor-highlight-active" timeout={2500}>
      <div
        className="ps__coor-highlight h-12 w-12 -ml-6 -mt-6 md:h-16 md:w-16 md:-ml-8 md:-mt-8"
        style={{
          left: `${coords.x + 2}px`,
          top: `${coords.y - menu + 2}px`,
        }}
      />
    </CSSTransition>
  );
};

export default HighlightCoordinate;
